<template>
  <div v-if="!isLoading">
    <div class="pl-4 pt-3 pb-3">
      <h3>
        <b>Overview</b>
      </h3>
      <v-layout row wrap v-if="account">
        <v-flex xs6 class="label">
          <v-icon>person</v-icon>
          <a
            :href="`http://vmcrm.quanlyxe.vn/index.php?module=Accounts&action=DetailView&record=${account.Id}`"
            target="_blank"
          >Name: {{account.Name}}</a>
        </v-flex>
        <v-flex xs6 class="label">
          <v-icon>perm_identity</v-icon>
          Username: {{account.Username}}
        </v-flex>
        <v-flex xs6 class="label">
          <v-icon>pin_drop</v-icon>
          Tracking Account: {{account.TrackingAccount}}
        </v-flex>
        <v-flex xs6 class="label">
          <v-icon>phone</v-icon>
          Office Phone: {{account.Phone }}
        </v-flex>
        <v-flex xs6 class="label">
          <v-icon>code</v-icon>
          <a
            :href="`http://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=${account.TaxCode}`"
            target="_blank"
          >VAT Code: {{account.TaxCode}}</a>
        </v-flex>
        <v-flex xs6 class="label">
          <v-icon>location_on</v-icon>
          Billing Address: {{account.Address}}
        </v-flex>
        <v-flex xs6 class="label">
          <v-icon>contacts</v-icon>
          Primary Contact Name: {{account.PrimaryContactName}}
        </v-flex>
        <v-flex xs6 class="label">
          <v-icon>contact_phone</v-icon>
          Primary Contact Phone: {{account.PrimaryContactPhone}}
        </v-flex>
        <v-flex xs6 class="label">
          <v-icon>contact_mail</v-icon>
          Primary Contact Email: {{account.PrimaryContactEmail}}
        </v-flex>
        <v-flex xs12 class="label">
          <v-icon>note</v-icon>
          Description: {{account.Remark}}
        </v-flex>
      </v-layout>
    </div>

    <v-divider></v-divider>
    <crm-cases v-if="account" :name="account.Name" :isLoading="isLoadingCases" :datasource="cases"></crm-cases>

    <v-divider></v-divider>
    <crm-contacts
      v-if="account"
      :name="account.Name"
      :isLoading="isLoadingContacts"
      :datasource="contacts"
    ></crm-contacts>
  </div>
  <div v-else>
    <loading-panel></loading-panel>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import CrmCases from './CrmCases';
import CrmContacts from './CrmContacts';
import LoadingPanel from './LoadingPanel';

export default {
  components: { CrmCases, CrmContacts, LoadingPanel },

  props: {
    trackingId: Number
  },
  data () {
    return {
      account: null,
      isLoading: false,

      cases: [],
      isLoadingCases: false,

      contacts: [],
      isLoadingContacts: false
    };
  },
  created () {
    if (this.trackingId) {
      this.getAccount();
    }
  },
  methods: {
    ...mapActions(['AccountRequest', 'CasesRequest', 'ContacsRequest']),

    getAccount () {
      this.isLoading = true;
      this.AccountRequest(this.trackingId)
        .then(res => {
          this.account = res;
          if (res.Id) {
            this.getCases(res.Id);
            this.getContacts(res.Id);
          }
        })
        .catch(_ => {
          this.account = null;
        })
        .finally(_ => {
          this.isLoading = false;
        });
    },

    getCases (accountId) {
      this.isLoadingCases = true;
      this.cases = [];
      this.CasesRequest(accountId)
        .then(res => {
          this.cases = res;
        })
        .catch(_ => {
          this.cases = [];
        })
        .finally(_ => {
          this.isLoadingCases = false;
        });
    },

    getContacts (accountId) {
      this.isLoadingContacts = true;
      this.contacts = [];
      this.ContacsRequest(accountId)
        .then(res => {
          this.contacts = res;
        })
        .catch(_ => {
          this.contacts = [];
        })
        .finally(_ => {
          this.isLoadingContacts = false;
        });
    }
  }
};
</script>

<style scoped>
.label {
  padding-top: 8px;
}
.v-icon {
  padding-right: 16px;
}
</style>




// WEBPACK FOOTER //
// src/pages/search/components/CrmInfo.vue